import { TimeCard } from './timecard';
import { ApiTimecard } from "./apiTimecard";
import { TimecardRow } from "./timecardrow";
import { Project } from "./project";
import { Task } from "./task";

export class Week {
    weekNo = '';
    firstDayOfWeek: string = '';
    lastDayOfWeek: string = '';
    status: string = '';
    timeCardId: number = -1;
    timeCard: TimeCard = new TimeCard();
    displayWeek: String = '';

    static fromApi(apiWeek: ApiTimecard): Week {
        let week = new Week();
        week.timeCard.timeCardId = apiWeek.timeCardId; 
        week.timeCard.status = apiWeek.status.toLowerCase();
        week.timeCard.empComment = apiWeek.empComment;
        week.timeCard.message = apiWeek.message;

        for( let post of apiWeek.taskDays){
            let row = week.timeCard.timecardRows.filter(x => x.project.projNo == post.projNo && x.task.taskNo == post.taskNo);
            if ( row.length > 0 ){
                row[0].setHoursOnDay(post.day, post.hours, post.timeId);
            }
            else {
                let timecardRow = new TimecardRow();
                timecardRow.project = new Project();
                timecardRow.project.projNo = post.projNo;
                timecardRow.project.expType = post.expType;
                timecardRow.project.projName = post.projName;
                
                timecardRow.task = new Task();
                timecardRow.task.projNo = post.projNo;
                timecardRow.task.expType = post.expType;
                timecardRow.task.taskNo = post.taskNo;
                timecardRow.task.taskName = post.taskName;
                timecardRow.task.startDt = post.startDt;
                timecardRow.task.endDt = post.endDt;
                timecardRow.message = post.message;

                timecardRow.project.tasks = new Array<Task>();
                timecardRow.project.tasks.push(timecardRow.task);

                timecardRow.setHoursOnDay(post.day, post.hours, post.timeId);
                week.timeCard.timecardRows.push(timecardRow);
            }
        }

        return week;
    }

    static fromJSONArray(weeks: Array<any>): Week[] {
        return weeks.map(week => new Week(week));
    }

    constructor(week?: any) {
        if (!!week) {
            this.timeCard = new TimeCard(week['timecard']);
            this.weekNo = week['weekNo'];
            this.firstDayOfWeek = week['firstDayOfWeek'];
            this.lastDayOfWeek = week['lastDayOfWeek'];
            this.status = week['status'].toLowerCase();
            this.timeCardId = week['timeCardId'];
        } else {
            this.timeCard = new TimeCard();
        }
    }
}

